/**
 * See Array.isArray.
 * @memberof npaw.Util
 */
module.exports = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]'
}
